
const BASE_URL = ENV_DEV ? "https://user.t.quanmaikeji.com" : "https://user.quanmaikeji.com";
const SHOP_URL = ENV_DEV ? "https://shop.t.quanmaikeji.com" : "https://shop.quanmaikeji.com";
const APP_URL = ENV_DEV ? "https://android.t.quanmaikeji.com" : "https://android.quanmaikeji.com";
export default {
    BASE_URL,
    SHOP_URL,
    APP_URL
}
//token 临时票据


// WEBPACK FOOTER //
// ./src/service/params.js